<template>
<div>
    <div class="topbar">
      <i @click="toIndex"></i>
      <!-- <span>{{$t('nav_name')}}</span> -->
      <div class="mainBox1">
        <div class="changeLangBtn" @click.stop="moreLang()">
          {{ $t("language") }}
          <em class="iconfont icon-een"></em>
          <ul v-show="changeLangBox" class="chooseLangUl">
            <li v-for="(item,index) in langList" class="chooseLangUlli" :key="index" @click="setLanguage(item.id)">{{item.name}}</li>
          </ul>
        </div>
        <div class="changeLangBtn1" @click.stop="goLogin()">{{$t('homepage_button1')}}</div>
      </div>
    </div>

    <div class="banner">
      <div class="forget" id="forget">
        <div class="forgetPsd" v-show="isShow">{{$t('setPass_title')}}</div>
        <div class="forgetPsd" v-show="!isShow">{{$t('sucPass_title')}}</div>
        <!-- <span class="line"></span>  -->
        <div class="inputItem clearfix" v-show="isShow">
          <span class="account">{{$t('setPass_txt1')}}</span><input type="password" v-model="password" @blur="checkPwd" @focus="checkPwd1">
          <span class="s1" v-show="pwdShow1">{{$t('setPass_txt2')}}</span>
        </div>
        <div class="inputItem clearfix" v-show="isShow">
          <span class="account">{{$t('setPass_txt1')}}</span><input v-model="password1" type="password" @blur="checkPwd2" @focus="checkPwd3">
          <span class="s1" v-show="pwdShow2" v-text="pwdAgain"></span>
        </div>
        <button v-show="isShow" class="signIn" @click="sucess">{{$t('setPass_txt4')}}</button>
        <button style="margin-top:60px" @click="goHome" v-show="!isShow" class="signIn">{{$t('sucPass_button')}}</button>
        <span v-show="warnShow" v-text="warinningText" class="s11" >{{$t('signup_txt7')}}</span>
      </div>
    </div>
</div>
</template>

<script>
import md5 from 'js-md5';
import I18nUtils from "@/utils/i18nUtils";

export default {
  name: 'setPwd',
  data () {
    return {
      isShow:true,
      pwdShow1:false,
      pwdShow2:false,
      pwdAgain:'',
      password1:'',
      password:'',
      pwdReg:false,
      pwdReg1:false,
      token:'',
      warnShow:false,
      warinningText:'',
      emailVerify:'',
      changeLangBox:false,
      langList: I18nUtils.langList,

    }
  },
  mounted () {
    I18nUtils.initLanguage(this);
    // this.token = this.getQueryVariable('token')
    this.pwdAgain = this.$t('signup_note3');

  },
  watch: {

  },
  methods: {
    setLanguage(lang) {
      I18nUtils.updateDivLanguage(lang);
      I18nUtils.setLanguage(this, lang);
    },
    
    getQueryVariable(variable){
        var query = window.location.href.substring(1);
        var vars = query.split("?");
        vars = vars[1].split("&");
        for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable){return pair[1];}
        }
        return null
    },

    sucess(){
      if(this.password1 != this.password){
        this.pwdShow2 = true;
        this.pwdAgain = this.$t('signup_note3')
        return;
      }
      if(this.pwdReg && this.pwdReg1){
          if(!localStorage.getItem("myPhone")){
            this.$http.getAxios('/sms/resetPwdByEmail ', {
              method: 'post',
              data: {
                'token': this.token,
                'password': md5(this.password)
              },
            }).then((res) => {
              if(res.data.code == '0'){
                document.getElementById('forget').classList.add('forgetImp')
                this.isShow = false;
              }else if(res.code == '43'){
                this.warnShow = true;
                this.warinningText = this.$t('forPass_note7')
              }else{
                this.warnShow = true;
                this.warinningText = this.$t('bad_network')
              }
            }).catch(error =>{
                this.warnShow = true;
                this.warinningText = this.$t('bad_network')
            });
          }else{
            this.$http.getAxios('/sms/resetPwdByMobile ', {
              method: 'post',
              data: {
                'mobile': localStorage.getItem("myPhone"),
                'password': md5(this.password)
              },
            }).then((res) => {
              if(res.data.code == '0'){
                document.getElementById('forget').classList.add('forgetImp')
                this.isShow = false;
                localStorage.removeItem("myPhone")
              }else if(res.code == '43'){
                this.warnShow = true;
                this.warinningText = this.$t('forPass_note7')
              }else{
                this.warnShow = true;
                this.warinningText = this.$t('bad_network')
              }
            }).catch(error =>{
                this.warnShow = true;
                this.warinningText = this.$t('bad_network')
            });
          }
      }else if(this.password == ''){
        this.pwdShow1 = true;
      }else if(this.password1 == ''){
        this.pwdShow2 = true;
      }
    },

    goHome(){
      let item = sessionStorage.getItem("forget_channel");

      if (item !== "" && item !== null) {
        window.location.href = "https://" + item;
      } else {
        this.$router.push({ path:'/'});
        
      }
    },

    toIndex(){
      this.$router.push({ path:'/'})
    },
    checkPwd(){
       let reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/;
       if(reg.test(this.password)){
         this.pwdShow1 = false;
         this.pwdReg = true;
       }else{
         this.pwdShow1 = true;
       }
    },
    checkPwd1(){
      this.pwdShow1 = true;
    },
    checkPwd2(){
       let reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/;
       if(reg.test(this.password1) && this.password1 == this.password){
         this.pwdShow2 = false;
         this.pwdReg1 = true;
       }else{
         this.pwdShow2 = true;
         this.pwdAgain = this.$t('signup_note3')
       }
    },
    checkPwd3(){
      this.pwdShow2 = true;
      this.pwdAgain = this.$t('setPass_txt3')
    },
    moreLang(){
      this.changeLangBox = !this.changeLangBox;
    },

    goLogin(){
      this.$router.push({ path:'/signIn'})
    },
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped rel="stylesheet/scss" lang="scss">
.topbar{
    width: 100%;
    height: 60px;
    color: #aaf9fe;
    background: #122346;
    i{
      position: absolute;
      top: 8px;
      left: 40px;
      width: 172px;
      height: 46px;
      cursor: pointer;
      z-index: 99999999999999999;
      background: url('~@/assets/images/bigIcon.png') no-repeat center;
    }
}
.topbar span{
    font-size: 20px;
    line-height: 60px;
    margin-left: 100px;
}
.banner{
    width: 1200px;
    margin: 0 auto;
    .forget{
      height: 400px;
      width: 500px;
      position: absolute;
      top:50%;
      left: 50%;
      transform: translate(-50%,-50%);
      text-align: center;
    }
    .forgetPsd{
      // margin-left:15px;
      // width: 453px;
      height: 58px;
      // background: url('~@/assets/images/title.png') no-repeat  center;
      font-size: 38px;
      font-weight: 700;
      line-height: 58px;
      color: #37c2e5;
    }
}
.forgetImp{
  width: 1000px !important;
}
.inputItem{
  margin-top: 40px;
  position: relative;
  margin-bottom: 34px;
  input{
    width: 348px;
    padding-left: 118px;
    height: 56px;
    background-color: #ffffff;
    box-shadow: inset 0px 1px 3px 0px
      rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    line-height: 56px;
    font-size: 16px;
    border: 0;
  }
  .s1{
    position: absolute;
    left: 20px;
    bottom: -26px;
    font-size: 14px;
    color: red;
  }
  ::-webkit-input-placeholder{
    color: #999999;
  }
  :-moz-placeholder{
    color: #999999;
  }
  :-ms-input-placeholder{
    color: #999999;
  }
  .account{
    width: 110px;
    height: 33px;
    position: absolute;
    top:11px;
    line-height: 33px;
    left:17px;
    font-size: 16px;
    color: #010101;
    border-right: 1px solid  #999999;
  }
}
.signIn{
  width: 461px;
	height: 59px;
	background-color: #2d8c9e;
  border-radius: 29px;
  color: #fff;
  margin: 0 auto;
  border: 0;
  display: block;
  font-size: 20px;
  cursor: pointer;
}
.changeLangBtn{
    cursor: pointer;
    float: right;
    font-weight: normal;
    font-size: 18px;
    line-height: 60px;
  }
  .changeLangBtn1{
    cursor: pointer;
    float: right;
    font-weight: normal;
    font-size: 18px;
    line-height: 60px;
    margin-right: 20px;
  }
  .s11{
    display: block;
    margin-top: 20px;
    font-size: 18px;
    color: red;
}
.chooseLangUl{
    position: absolute;
    z-index: 111;
    li{
      height: 40px;
      cursor: pointer;
    }
  }
.settingBtn,.changeLangBtn{
    cursor: pointer;
    float: right;
    font-weight: normal;
    font-size: 18px;
    padding-right: 20px;
  }
  .mainBox1{
    height: 60px;
    position: absolute;
    top: 0;
    right: 20px;
    z-index: 323223;
}
</style>



// WEBPACK FOOTER //
// src/components/setPwd.vue